<div
  class="edit-word-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <form class="edit-word-word-dialog-form" [formGroup]="_form" (ngSubmit)="edit()">
    <div *ngIf="_deletedField">
      <div class="alert alert-success success-msg">
        <div>
          <ng-lottie width="30px" [options]="options"></ng-lottie>
        </div>
        <div>&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been deleted.</div>
      </div>
    </div>
    <div *ngIf="!_deletedField">
      <ddc-text-gradient class="text-2xl" [_text]="_cardTitle" [_type]="'1'"></ddc-text-gradient>
      <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
    </div>
    <!-- * First Container -->
    <div class="add-dialog-container" *ngIf="!_deletedField">
      <div class="alert alert-danger" *ngIf="_editError">
        {{ _editError }}
      </div>
      <div *ngIf="_editedField">
        <div class="alert alert-success success-msg">
          <div>
            <ng-lottie width="30px" [options]="options"></ng-lottie>
          </div>
          <div>&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been edited.</div>
        </div>
      </div>
      <!-- ! Title-->
      <div class="add-dialog-row-2">
        <!--  Title -->
        <mat-form-field class="add-dialog-word">
          <mat-label>{{ _titleText }}</mat-label>
          <input formControlName="_title" matInput placeholder="Ex. Apple" />
          <!-- * Errors -->
          <mat-error *ngIf="title.hasError('maxlength')">
            Maximum <strong>{{ _titleMaxLength }}</strong> characters.
          </mat-error>
          <mat-error *ngIf="title.hasError('required')"> Required. </mat-error>
        </mat-form-field>
      </div>
      <!-- ! Definition 1-->
      <div class="add-dialog-row-3" *ngIf="_isDic">
        <mat-form-field class="add-dialog-definition">
          <mat-label>Description</mat-label>
          <textarea
            formControlName="_description"
            matInput
            placeholder="Ex. The round fruit of a tree of the rose family"
          ></textarea>
          <!-- * Errors -->
          <mat-error *ngIf="description.hasError('maxlength')">
            Maximum <strong>{{ _descriptionMaxLength }}</strong> characters.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- ! Footer -->
    <mat-divider style="margin-bottom: 10px; margin-top: 20px"></mat-divider>
    <div class="edit-word-dialog-submit-container">
      <div class="edit-word-dialog-submit-container-right">
        <!-- Delete -->
        <button
          class="edit-word-dialog-delete-btn"
          *ngIf="!_deletedField"
          color="accent"
          mat-flat-button
          type="button"
          (click)="openDeleteDialog()"
        >
          <mat-icon>delete</mat-icon>Delete
        </button>
        <!-- Edit -->
        <ddc-button-s-one
          class="ddc-submit-btn"
          *ngIf="!_deletedField"
          [_isLoading]="_isEditBtnLoading"
          [_label]="_submitBtnText"
          (buttonClick)="edit()"
        ></ddc-button-s-one>
      </div>
      <div class="edit-word-dialog-submit-container-left">
        <!-- Cancel -->
        <button class="edit-word-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Cancel</button>
      </div>
    </div>
  </form>
</div>
